export default function SowJudicaFolderIco() {
  return (
    <svg
      width="17"
      height="22"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.46634C1 2.7196 1 2.34623 1.14533 2.06102C1.27315 1.81013 1.47713 1.60616 1.72801 1.47833C2.01323 1.33301 2.3866 1.33301 3.13333 1.33301H5.44968C5.7758 1.33301 5.93887 1.33301 6.09233 1.36985C6.22833 1.40251 6.3584 1.45638 6.47773 1.52949C6.61227 1.61194 6.7276 1.72724 6.9582 1.95785L7.0418 2.0415C7.2724 2.27211 7.38773 2.38741 7.52227 2.46986C7.6416 2.54297 7.77167 2.59684 7.90767 2.6295C8.06113 2.66634 8.2242 2.66634 8.55033 2.66634H10.8667C11.6134 2.66634 11.9868 2.66634 12.272 2.81167C12.5229 2.93949 12.7269 3.14347 12.8547 3.39435C13 3.67957 13 4.05294 13 4.79967V8.53301C13 9.27974 13 9.65314 12.8547 9.93834C12.7269 10.1892 12.5229 10.3932 12.272 10.521C11.9868 10.6663 11.6134 10.6663 10.8667 10.6663H3.13333C2.38659 10.6663 2.01323 10.6663 1.72801 10.521C1.47713 10.3932 1.27315 10.1892 1.14533 9.93834C1 9.65314 1 9.27974 1 8.53301V3.46634Z"
        stroke="#6947B0"
        stroke-width="1.45455"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
